<template>
  <div class="wrapper">
    <div v-if="canAddGroup">
      <AddLocationGroup
        ref="addButton"
        v-if="canBulkAdd"
        :location-group-type="locationGroupType"
        :has-permission="hasGroupAddPermission"
        :owner-profile-id="ownerProfileId"
        :geocoder="geocoder"
      />
      <v-btn
        v-else
        @click="onClickAdd"
        :loading="mapLoading"
        small
        color="primary"
      >
        <v-icon>add</v-icon><span>追加</span>
      </v-btn>
    </div>
    <PointGroupList
      v-if="!mapLoading"
      @targetGroupType="handleTargetGroupType"
      :group-list="groupList"
      :location-group-type="locationGroupType"
      :has-edit-permission="hasEditPermission"
      :geocoder="geocoder"
    />
  </div>
</template>

<script>
import PointGroupList from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/PointGroupList'
import AddLocationGroup from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/AddLocationGroup'
import { locationGroupType as LocationGroupType } from '../constants'
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'

export default {
  name: 'LocationGroup',
  components: {
    PointGroupList,
    AddLocationGroup,
  },
  props: {
    groupList: {
      type: Array,
      default: () => [],
    },
    locationGroupType: {
      type: String,
      default: LocationGroupType.CUSTOM_LOCATION,
    },
    hasEditPermission: {
      type: Boolean,
      default: false,
    },
    geocoder: {
      type: Function,
      required: true,
    },
    canAddGroup: {
      type: Boolean,
      default: false,
    },
    hasGroupAddPermission: {
      type: Boolean,
      default: false,
    },
    ownerProfileId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      canBulkAdd: this.locationGroupType === LocationGroupType.CUSTOM_LOCATION,
    }
  },
  computed: {
    mapLoading() {
      // 地点グループが1つも無い時はマップがロードされないので false
      if (this.groupList.length === 0) return false
      return !this.$store.getters[getters.mapLoaded]
    },
    hasUpdates() {
      return this.$store.getters[getters.targetGroupHasUpdates]
    },
    isEditingPoiCategory() {
      return this.$store.getters[getters.isEditingPoiCategory]
    },
  },
  methods: {
    async onClickAdd() {
      // 変更があれば確認する
      if (this.hasUpdates) {
        const result = await this.$confirm(
          '追加・編集が破棄されますがよろしいですか？',
        )
        if (!result) return
      } else if (this.isEditingPoiCategory) {
        const result = await this.$confirm(
          'カテゴリーグループの地点追加/変更中ですがよろしいですか？',
        )
        if (!result) return
      }
      this.$store.dispatch(actions.CLEAR_TARGET_GROUP)
      this.$store.dispatch(actions.SET_IS_EDITING_POI_CATEGORY)
    },
    handleTargetGroupType(targetGroupType) {
      this.$emit('targetGroupType', targetGroupType)
    },
  },
}
</script>

<style scoped>
.wrapper {
  background-color: white;
}
</style>
